import { render, staticRenderFns } from "./AnxCrudTable.vue?vue&type=template&id=1d4bd6ac&scoped=true&"
import script from "./AnxCrudTable.vue?vue&type=script&lang=ts&"
export * from "./AnxCrudTable.vue?vue&type=script&lang=ts&"
import style0 from "./AnxCrudTable.vue?vue&type=style&index=0&id=1d4bd6ac&lang=scss&scoped=true&"
import style1 from "./AnxCrudTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4bd6ac",
  null
  
)

export default component.exports